export default Object.freeze({
    'FrontPageSlider': 'FrontPageSlider',
    'AllPageTopSlider': 'AllPageTopSlider',
    'NewSeason': 'NewSeason',
    'FeaturedCollection': 'FeaturedCollection',
    'MostSale': 'MostSale',
    'Take3Pay2': 'Take3Pay2',
    'Ads': 'Ads',
})